class Datalayer {
	constructor() {
		// this.dataLayer = window.dataLayer || [];
		this.pushDatalayerLoaded();
		// console.log("init");
		// t
	}

	pushDatalayerLoaded() {
		// console.log(this.dataLayer);
		$("[data-page]").each(function() {
			dataLayer.push($(this).data("page"));
		});
	}
}